import { render, staticRenderFns } from "./TifPostulacionesForm.vue?vue&type=template&id=100161bc"
import script from "./TifPostulacionesForm.vue?vue&type=script&lang=js"
export * from "./TifPostulacionesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports